import React, { lazy, Suspense, memo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import i18n from 'i18next';
import Loading from 'components/shared-components/Loading';
import { lightTheme, darkTheme } from 'configs/ThemeConfig';
import { resources } from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import Routes from 'routes'
import { getMe } from 'store/slices/authSlice';
import { useEffect } from 'react';

const DAYJS_LOCALE_MAP = { en: 'en', es: 'es' };
const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
	const dispatch = useDispatch();
	const token = useSelector(state => state.auth.token);
	const me = useSelector(state => state.auth.me);

	useEffect(() => {
		if (token && !me) {
			dispatch(getMe());
		}
	}, [token, me, dispatch]);

	const blankLayout = useSelector(state => state.theme.blankLayout);

	const Layout = token && !blankLayout ? AppLayout : AuthLayout;

	const locale = useSelector(state => state.theme.locale);

	useEffect(() => {
		if (i18n.language !== locale) {
			i18n.changeLanguage(locale);
		}
		dayjs.locale(DAYJS_LOCALE_MAP[locale] || 'en');
	}, [locale]);

	const direction = useSelector(state => state.theme.direction);

	const currentTheme = useSelector(state => state.theme.currentTheme);

	const currentAppLocale = resources[locale];

	useBodyClass(`dir-${direction}`);

	const themeConfig = currentTheme === 'light' ? { ...lightTheme } : { ...darkTheme }

	return (
		<ConfigProvider theme={themeConfig} direction={direction} locale={currentAppLocale.antd}>
			<Suspense fallback={<Loading cover="content" />}>
				<Layout>
					<Routes />
				</Layout>
			</Suspense>
		</ConfigProvider>
	)
}


export default memo(Layouts)